import { render, staticRenderFns } from "./ViewResultSendButton.vue?vue&type=template&id=48efe4ce&scoped=true&"
import script from "./ViewResultSendButton.vue?vue&type=script&lang=js&"
export * from "./ViewResultSendButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewResultSendButton.vue?vue&type=style&index=0&id=48efe4ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efe4ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
